import type { StorageManagerInitContext } from './StorageManagerInitContext';
import { getRemoteLocalStorage } from './getRemoteLocalStorage';

export async function preloadLocalStorage(context: StorageManagerInitContext) {
	return getRemoteLocalStorage(context);
}
